import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Link } from '@mui/material';
import CodigoVerificacao from './CodigoVerificacao';
import PerguntaSeguranca from './PerguntaSeguranca';
import CodigoAdministrador from './CodigoAdministrador';

const PREFIX = 'AutenticacaoDoisFatores';

const classes = {
  root: `${PREFIX}-root`,
  card: `${PREFIX}-card`,
  image: `${PREFIX}-image`,
  content: `${PREFIX}-content`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.card}`]: {
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
    },
  },

  [`& .${classes.image}`]: {
    maxWidth: '100%',
    maxHeight: '100%',
  },

  [`& .${classes.content}`]: {
    padding: theme.spacing(3, 4, 3, 4),
  },
}));

interface Props {
  telaAtiva: string;
  setTelaAtiva: (telaAtiva: string) => void;
}

const AutenticacaoDoisFatores: FC<Props> = ({ telaAtiva, setTelaAtiva }) => {
  return (
    <StyledCard className={classes.card}>
      <CardContent className={classes.content}>
        <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
          <img
            alt="Logo CIGAM"
            src="/static/client/logo.png"
            onError={ev => {
              ev.currentTarget.src = '/static/images/logo-cigam.png';
            }}
            className={classes.image}
          />
        </Box>
        <Box mt={1}>
          {telaAtiva === 'codigo' && <CodigoVerificacao />}
          {telaAtiva === 'pergunta' && (
            <PerguntaSeguranca setTelaAtiva={setTelaAtiva} />
          )}
          {telaAtiva === 'administrador' && <CodigoAdministrador />}
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center" mt={3}>
          <Link
            href="https://www.cigam.com.br"
            target="_blank"
            underline="hover"
          >
            <img
              alt="Desenvolvido por CIGAM"
              src="/static/images/powered-cigam.png"
            />
          </Link>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default AutenticacaoDoisFatores;
